import { BarleyOffIcon } from './BarleyOffIcon';

/**
 * author: Simran
 * id 6627D247-B25C-48F3-925D-BF282D7B4295
 * name barley-off
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/barley-off.svg
 * tags
 * - Agriculture 
 */
export const GrainOffIcon = BarleyOffIcon;
export default GrainOffIcon